




















































import Vue from 'vue';
import Component from 'vue-class-component';
import TicketForm from '@/components/tickets/tickets-form/TicketForm.vue';
import NetworkSecurityInternetGeneralInformation from '@/modules/tickets/requirement/network-security-internet/components/NetworkSecurityInternetGeneralInformation.vue';
import NetworkSecurityInternetTicketConfirmation from '@/modules/tickets/requirement/network-security-internet/components/NetworkSecurityInternetTicketConfirmation.vue';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { layout, user } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { networkSecurityAndInternet } from '@/modules/tickets/shared/store/namespaces';
import { NetworkSecurityInternetActions } from '@/modules/tickets/requirement/network-security-internet/store/network-security-internet.actions';
import { NetworkSecurityInternetGetters } from '@/modules/tickets/requirement/network-security-internet/store/network-security-internet.getters';
import { NetworkSecurityInternetGeneralInformationData } from '@/modules/tickets/requirement/network-security-internet/domain/network-security-internet-general-information';
import { Typing } from '@/modules/tickets/shared/domain/typing';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';

@Component({
    name: 'network-security-internet',
    components: {
        NetworkSecurityInternetTicketConfirmation,
        NetworkSecurityInternetGeneralInformation,
        TicketForm,
    },
})
export default class NetworkSecurityInternet extends Vue {
    private currentStep: number = 1;
    private isValid: boolean = true;
    private highestStepReached: number = 1;
    private isMounted = false;

    async mounted() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        this.changeTitle({
            title: 'Requerimiento de Redes, Seguridad e Internet',
            route: ['TICKETS'],
        });

        const failed = await this.fetchView();

        if (failed) {
            failed.showError();
        }

        this.isMounted = true;
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    async sendRequirementTicket() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        const failed = await this.createTicket(this.formValues.generalInformation);
        if (failed) {
            failed.showError();
        } else {
            this.$router.push({
                name: 'tickets',
            });
        }
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    nextStep() {
        if (this.currentStep < 2) {
            this.currentStep++;
            this.highestStepReached = this.currentStep;
        }
    }

    previousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE) changeTitle!: (title: LayoutTitle) => void;

    @networkSecurityAndInternet.Getter(NetworkSecurityInternetGetters.GET_FORM_VALUES)
    formValues!: {
        generalInformation: NetworkSecurityInternetGeneralInformationData;
        typings: Typing[];
    };

    @networkSecurityAndInternet.Action(NetworkSecurityInternetActions.FETCH_VIEW)
    fetchView!: () => Promise<RequestResponse>;

    @networkSecurityAndInternet.Action(NetworkSecurityInternetActions.CREATE_TICKET)
    createTicket!: (
        information: NetworkSecurityInternetGeneralInformationData,
    ) => Promise<RequestResponse>;
}
